import React from 'react';
import { Empty, Scrollbar, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import { AreaChart, ChartYHanle, BarChart, DonutChart } from './common';
import { runtime } from 'codeArt/common';

export class ScrapChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "废品";
        this.unit = "数量";
        this.yName = "废品/个";
        this.yHanle = ChartYHanle.numerical;
    }
}

export class ScrapRateHourChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "废品率 每小时";
        this.unit = "废品率";
        this.yName = "废品率/每小时";
        this.yHanle = ChartYHanle.ratio;
    }

}

export class ScrapRateChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "废品率";
        this.unit = "废品率";
        this.yName = "废品率[%]";
        this.yHanle = ChartYHanle.ratio;
    }

    getDataY() {
        return { format: (v) => { return v + "%" } }
    }

    getMarkData() {
        if (this.props.mark === false) return null;
        return { handle: "last" };
    }

    getGrid() {
        if (runtime.mobile){
            return {left: '5', right: '0'}
        }
    }
}

export class LastScrapRateChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "废品率";
        this.unit = "废品率";
        this.yName = "废品率[%]";
        this.yHanle = ChartYHanle.ratio;
    }

    getDataY() {
        return { format: (v) => { return v + "%" } }
    }

    getX() {
        return [15, 30, 45, 60];
    }
}


export class ScrapRateMinuteChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "废品率/10分钟";
        this.unit = "废品率";
        this.yName = "废品率/10分钟";
        this.yHanle = ChartYHanle.ratio;
    }


    getGrid() {
        return { left: '55', right: '10', top: "15", bottom: "0", containLabel: true, };
    }

}


// export class Top5ScrapChart extends BarChart {

//     constructor(props) {
//         super(props);
//         this.title = "Top5废品计数";
//     }

//     getX() {
//         let { data } = this.props;
//         let max = 0;
//         data.forEach((t) => {
//             if (t.value > max) max = t.value;
//         });

//         max = max + parseInt(max / 3);
//         return { min: 0, max: max, interval: 10 };
//     }

//     getY() {
//         return { min: null, max: null, interval: null };
//     }

//     getGrid() {
//         return { left: 0, right: 15, bottom: 0, top: 20 };
//     }
// }


export class ExcludingCount extends BarChart {

    constructor(props) {
        super(props);
        this.title = "";
    }

    getY() {

        let { data } = this.props;

        let max = 0;
        data.forEach((t) => {
            if (t.value > max) max = t.value;
        });

        max = parseInt((max + parseInt(max / 3)) / 10) * 10;
        return { min: 0, max: max, interval: 50 };
    }

    getX() {
        return { axisLabel: { interval: 0 } };
    }


    getGrid() {
        return { left: 0, right: 15, bottom: 0, top: 20 };
    }
}

export class ExcludingRate extends DonutChart {

    constructor(props) {
        super(props);
        this.state = {

        }
    }
}
